import { FontIcon } from "@fluentui/react";
import { Tooltip } from "antd";
import { useAppDispatch } from "../../../redux/useAppDispatch";
import { getDocumentInfo, getDocumentPresigned, openDeleteTranslationDocument, openDocumentInfoModal, openEditTranslationDocument, openViewDocument, rearchiveDocument, setSelectedRecord, startTranslation, stopTranslation, storeDocumentInfo } from "../../../redux/EngageTranslation/EngageTranslationAction";
import DocumentDetailNavigationButton from "./DocumentDetailNavigationButton";
import AuditPageNavigationButton from "./AuditPageNavigationButton";
import { useNavigate } from "react-router";
interface ActionColumnProps {
  type: string;
  record: any;
}
function ActionColumn(props: ActionColumnProps) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const failures = ["Translation Stopped", "Translation Failed", "Translation Stopped", "Failed"];

  switch (props.type) {
    case "new":
      return (
        <div className="d-flex gap-2 w-100 justify-content-center">
          {props.record.status === "Translation In Progress" || props.record.status === "Translation In Queue" ? (
            <Tooltip
              placement="bottom"
              title={"Stop translation"}>
              <button
                className="button action"
                onClick={() => dispatch(stopTranslation({ selectedDocumentID: props.record.documentId, selectedID: props.record.id }))}>
                <FontIcon iconName="Pause" />
              </button>
            </Tooltip>
          ) : (
            <Tooltip
              placement="bottom"
              title={"Start translation"}>
              <button
                className="button action"
                disabled={props.record.status !== "New"}
                onClick={() => dispatch(startTranslation({ selectedDocumentID: props.record.documentId, selectedID: props.record.id }))}>
                <FontIcon iconName="Play" />
              </button>
            </Tooltip>
          )}

          {props.record.status === "Translation Failed" || props.record.status === "Translation In Progress" || props.record.status === "Translation In Queue" || props.record.status === "Translation Stopped" ? (
            <AuditPageNavigationButton
              id={props.record.documentId}
              name={props.record.name}
            />
          ) : (
            <Tooltip
              placement="bottom"
              title={"Edit translation job"}>
              <button
                className="button action"
                disabled={!(props.record.status === "New" || props.record.status === "Virus Scan In Progress") || props.record.uploadType === "Quick"}
                onClick={() => {
                  dispatch(
                    setSelectedRecord({
                      view: "new",
                      selectedRecordID: props.record.id,
                      selectedDocumentID: props.record.documentId,
                    })
                  );
                  dispatch(openEditTranslationDocument());
                }}>
                <FontIcon iconName="Edit" />
              </button>
            </Tooltip>
          )}

          <Tooltip
            placement="bottom"
            title={"Delete translation job"}>
            <button
              className="button action"
              disabled={props.record.status === "Virus Scan In Progress" || props.record.status === "Translation In Progress" || props.record.status === "Translation In Queue"}
              onClick={() => {
                dispatch(
                  setSelectedRecord({
                    view: "new",
                    selectedRecordID: props.record.id,
                    selectedDocumentID: props.record.documentId,
                  })
                );
                dispatch(
                  storeDocumentInfo({
                    selectedRecordName: props.record.name,
                    selectedRecordID: props.record.id,
                    selectedDocumentID: props.record.documentId,
                  })
                );
                dispatch(openDeleteTranslationDocument());
              }}>
              <FontIcon iconName="Delete" />
            </button>
          </Tooltip>
        </div>
      );
    case "quality-control":
      return (
        <div className="d-flex gap-2 w-100 justify-content-center">
          <Tooltip
            placement="bottom"
            title={"Document information"}>
            <button
              onClick={() => {
                dispatch(getDocumentInfo({ documentID: props.record.documentId, ID: props.record.id }));
                dispatch(openDocumentInfoModal());
              }}
              className="button action">
              <FontIcon iconName="Info" />
            </button>
          </Tooltip>
          <AuditPageNavigationButton
            id={props.record.documentId}
            name={props.record.name}
          />
          <DocumentDetailNavigationButton record={props.record} />
        </div>
      );
    case "client-ready":
      return (
        <div className="d-flex gap-2 w-100 justify-content-center">
          <Tooltip
            placement="bottom"
            title={"Download document"}>
            <button
              className="button action"
              onClick={() => {
                dispatch(
                  getDocumentPresigned({
                    selectedRecordID: props.record.id,
                    selectedDocumentID: props.record.documentId,
                    action: "download",
                  })
                );
              }}>
              <FontIcon iconName="Download" />
            </button>
          </Tooltip>
          <AuditPageNavigationButton
            id={props.record.documentId}
            name={props.record.name}
          />
          <Tooltip
            placement="bottom"
            title={"View document"}>
            <button
              className="button action"
              onClick={() => {
                dispatch(openViewDocument());
                setSelectedRecord({ view: "client-ready", selectedRecordID: props.record.id, selectedDocumentID: props.record.documentId });
                dispatch(
                  getDocumentPresigned({
                    selectedRecordID: props.record.id,
                    selectedDocumentID: props.record.documentId,
                    action: "view",
                  })
                );
              }}>
              <FontIcon iconName="View" />
            </button>
          </Tooltip>
        </div>
      );
    case "archived":
      return (
        <div className="d-flex gap-2 w-100 justify-content-center">
          <AuditPageNavigationButton
            id={props.record.documentId}
            name={props.record.name}
          />
          <Tooltip
            placement="bottom"
            title={"Reinstate"}>
            <button
              className="button action"
              disabled={failures.includes(props.record.status) ? true : false}
              onClick={() => {
                dispatch(rearchiveDocument({ documentId: props.record.documentId, docId: props.record.id }));
              }}>
              <FontIcon iconName="ReturnToSession" />
            </button>
          </Tooltip>
        </div>
      );
    case "all":
      let viewName = props.record.viewName;

      if (props.record.isArchived) {
        viewName = "archived";
      }

      return (
        <ActionColumn
          type={viewName}
          record={props.record}
        />
      );
  }
  return <div></div>;
}

export default ActionColumn;
